import React, { createContext, useContext, useState, useCallback, useRef } from 'react';
import '../animations';

const ToastContext = createContext(null);

const TYPE_STYLES = {
  success: { background: '#f0fdf4', color: '#15803d', border: '1px solid #bbf7d0' },
  error:   { background: '#fef2f2', color: '#b91c1c', border: '1px solid #fecaca' },
  info:    { background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe' },
};

const s = {
  container: {
    position: 'fixed',
    bottom: 24,
    right: 24,
    zIndex: 9999,
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    pointerEvents: 'none',
  },
  toast: {
    minWidth: 260,
    maxWidth: 360,
    padding: '12px 16px',
    borderRadius: 10,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 1.4,
    boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    animation: 'tmFadeUp 0.2s ease',
    pointerEvents: 'auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 12,
  },
  close: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: 16,
    lineHeight: 1,
    padding: 0,
    opacity: 0.5,
    flexShrink: 0,
  },
};

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const idRef = useRef(0);

  const showToast = useCallback((message, type = 'info', duration = 4000) => {
    const id = ++idRef.current;
    setToasts((prev) => [...prev, { id, message, type }]);
    if (duration > 0) {
      setTimeout(() => setToasts((prev) => prev.filter((t) => t.id !== id)), duration);
    }
  }, []);

  function dismiss(id) {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      <div style={s.container}>
        {toasts.map((t) => (
          <div key={t.id} style={{ ...s.toast, ...TYPE_STYLES[t.type] }}>
            <span>{t.message}</span>
            <button style={{ ...s.close, color: TYPE_STYLES[t.type].color }} onClick={() => dismiss(t.id)}>✕</button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used inside ToastProvider');
  return ctx;
}
